(function () {
  var dlg = document.querySelector('.hl-pdpm');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  /* 24px rather than any movement at all: a tap that lands on the scroller can
     nudge it a pixel or two, and a sheet that jumps to full height on that reads
     as a misfire. 24 is past the noise and well short of a deliberate scroll. */
  function armExpand(dlg) {
    if (!dlg.classList.contains('hl-pdpm--half')) return;
    var sc = dlg.querySelector('.hl-pdpm__scroll');
    if (!sc || sc.dataset.hlExpand === '1') return;
    sc.dataset.hlExpand = '1';
    sc.addEventListener('scroll', function () {
      if (!dlg.classList.contains('hl-pdpm--half')) return;
      if (dlg.classList.contains('is-full')) return;
      if (sc.scrollTop > 24) dlg.classList.add('is-full');
    }, { passive: true });
  }

  var mount  = dlg.querySelector('[data-pm-mount]');
  var scroll = dlg.querySelector('[data-pm-scroll]');
  var crumb  = dlg.querySelector('[data-pm-crumb]');
  var full   = dlg.querySelector('[data-pm-full]');
  var panel  = dlg.querySelector('.hl-pdpm__panel');

  /* Which of the product template's sections come along, in the order the
     product page itself puts them (templates/product.json).

     hl_faq is deliberately not one of them. It renders on the product page as
     thirty-odd accordion rows — the why/how/what block written for search and
     for the answer engines, not for a reader who is one tap from a decision —
     and it took the modal's scroll from 1,900px to 5,775px, measured
     2026-09-06. The buy column already carries the FAQ card that answers the
     questions a buyer actually has (shipping, returns, materials), and the link
     at the foot of the modal goes to the page that has the rest. Add
     'hl_faq' back between the two below and it returns exactly as it renders
     on the product page; nothing else needs to change.

     Recommendations, the category rows and the review wall stay behind for the
     same reason, plus weight: the reviews are most of a 214 KB product page. */
  var SECTIONS = ['main', 'hl_description'];

  var STATE_KEY = 'hl_pdpm_v2';   // v2 2026-09-26: state now carries the inline styles

  function state() {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null'); } catch (e) { return null; }
  }
  function setState(v) {
    try {
      if (v) sessionStorage.setItem(STATE_KEY, JSON.stringify(v));
      else sessionStorage.removeItem(STATE_KEY);
    } catch (e) {}
  }
  function forget() { setState(null); cache = {}; }

  function abs(href) { try { return new URL(href, location.href).href; } catch (e) { return ''; } }

  /* ------------------------------------------------------------------ fetch
     Two shapes of answer, one shape of result: an ordered list of elements to
     mount, plus the stylesheets they need. */
  var cache = {};

  function fromDocument(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var nodes = [], ids = [], i;

    for (i = 0; i < SECTIONS.length; i++) {
      var el = doc.querySelector('[id^="shopify-section-template--"][id$="__' + SECTIONS[i] + '"]');
      if (!el) continue;
      ids.push(el.id.replace(/^shopify-section-/, ''));
      nodes.push(SECTIONS[i] === 'main' ? el.querySelector('.product-information') : el);
    }
    if (!nodes.length || !nodes[0]) return null;

    var css = [];
    var links = doc.querySelectorAll('link[rel="stylesheet"][href]');
    for (i = 0; i < links.length; i++) css.push(abs(links[i].getAttribute('href')));

    /* The product page's INLINE styles too, 2026-09-26. The compiled subset
       was not the whole difference: 31 <style> blocks (~127 KB) render only on
       the product template — the hl-pdp-v2 token scales, the title, the price
       badge, the half star, the gallery dots — so the modal showed a thinner,
       larger title, "17% off" as plain text and no half star (owner: "sửa lại
       PDP popup trong blogs cho giống với PDP chuẩn"). Blocks that belong to
       things the modal never mounts are left behind: the sticky buy bar. The
       ones inside the mounted sections come along with their markup already. */
    var styles = [];
    var tags = doc.querySelectorAll('style');
    for (i = 0; i < tags.length; i++) {
      var txt = tags[i].textContent || '';
      if (!txt.trim()) continue;
      if (nodes.some(function (n) { return n && n.contains(tags[i]); })) continue;
      // Only the buy bar's own block; the hl-pdp-v2 block mentions .hl-buybar too.
      if (/^\s*\.hl-buybar\s*\{/.test(txt)) continue;
      styles.push(txt);
    }

    /* Page-level scripts the modal needs, by name only: the gallery dots are
       rendered at the end of the product page, outside every section. */
    var scripts = [];
    var sTags = doc.querySelectorAll('script:not([src])');
    for (i = 0; i < sTags.length; i++) {
      var code = sTags[i].textContent || '';
      if (/__hlGalleryDots/.test(code)) scripts.push(code);
    }

    /* What the next fetch of the session gets to skip. The ids are learned
       rather than written down because `template--<id>__main` carries a
       Shopify template id that is not knowable from an article template and
       does not survive a theme being duplicated. */
    setState({ ids: ids, css: css, styles: styles, scripts: scripts });

    return { html: nodes.map(outer), css: css, styles: styles, scripts: scripts };
  }

  function fromSections(json, ids) {
    var nodes = [];
    for (var i = 0; i < ids.length; i++) {
      var body = json[ids[i]];
      if (!body) continue;
      var box = document.createElement('div');
      box.innerHTML = body;
      var isMain = /__main$/.test(ids[i]);
      var node = isMain ? box.querySelector('.product-information') : box.firstElementChild;
      if (node) nodes.push(node);
    }
    if (!nodes.length) return null;
    return { html: nodes.map(outer) };
  }

  function outer(el) { return el ? el.outerHTML : ''; }

  function get(handle) {
    if (cache[handle]) return cache[handle];

    var known = state();
    var url = (known && known.ids && known.ids.length)
      ? '/products/' + handle + '?sections=' + encodeURIComponent(known.ids.join(','))
      : '/products/' + handle;

    var p = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var data = known && known.ids
          ? fromSections(JSON.parse(text), known.ids)
          : fromDocument(text);
        if (!data) throw new Error('no product markup');
        if (!data.css && known) data.css = known.css || [];
        if (!data.styles && known) data.styles = known.styles || [];
        if (!data.scripts && known) data.scripts = known.scripts || [];
        return data;
      })
      .catch(function (err) {
        delete cache[handle];
        /* A remembered id that stopped resolving is worse than none: forget it
           and let the retry take the whole page and learn a fresh one. Once,
           so a genuinely dead product cannot loop. */
        if (known && known.ids) { forget(); return get(handle); }
        throw err;
      });

    cache[handle] = p;
    return p;
  }

  /* --------------------------------------------------------------- adopt CSS
     The article page and the product page load the same compiled stylesheet at
     different subsets — Shopify includes only the sections that render, and an
     article renders no product section. Measured 2026-09-06: 136 KB against
     184 KB, with zero rules for .product-information__grid on the article side.
     This adds the product page's subset, ~30 KB gzipped, and resolves before
     anything is mounted so the panel never paints an unstyled product page.

     A link that 404s means the theme was republished under this session's
     remembered URLs. That is not recoverable by waiting, so the memory is
     dropped and the next open re-learns everything from a whole page. */
  /* Inline blocks are matched by their text: a block already on this page
     (every snippet the article also renders) is skipped, so nothing is doubled. */
  /* The product page scopes much of its CSS to its own frame — `#MainContent h1`,
     `[id$='__main'] legend` — and the modal's content sits in a <dialog> outside
     the article's <main>, in a mount with no section id. Those selectors are
     re-aimed at the mount. That also means none of them can ever reach the
     article's own #MainContent. */
  function scopeCss(css) {
    return css
      .replace(/#MainContent\b/g, '[data-pm-mount]')
      .replace(/\[id\$=(['"])__main\1\]/g, '[data-pm-mount]');
  }

  var adoptedStyles = null;
  function adoptStyles(list) {
    if (!list || !list.length) return;
    if (!adoptedStyles) {
      adoptedStyles = {};
      var own = document.querySelectorAll('style');
      for (var i = 0; i < own.length; i++) adoptedStyles[own[i].textContent] = 1;
    }
    var frag = document.createDocumentFragment();
    for (var j = 0; j < list.length; j++) {
      /* A block the article also renders is already on the page, but a copy
         whose selectors say #MainContent or [id$='__main'] cannot reach the
         modal, so its re-aimed version is added all the same. */
      var scoped = scopeCss(list[j]);
      var key = scoped === list[j] ? list[j] : 'scoped:' + scoped;
      if (adoptedStyles[key]) continue;
      adoptedStyles[key] = 1;
      var s = document.createElement('style');
      s.setAttribute('data-hl-pdpm-style', '');
      s.textContent = scoped;
      frag.appendChild(s);
    }
    if (frag.childNodes.length) document.head.appendChild(frag);
  }

  var ranPage = {};
  function runPageScripts(list) {
    for (var i = 0; list && i < list.length; i++) {
      if (ranPage[list[i]]) continue;
      ranPage[list[i]] = 1;
      var s = document.createElement('script');
      s.textContent = list[i];
      document.body.appendChild(s);
    }
  }

  var adopted = {};
  function adoptCss(list) {
    if (!list || !list.length) return Promise.resolve();

    var have = {}, i;
    var links = document.querySelectorAll('link[rel="stylesheet"][href]');
    for (i = 0; i < links.length; i++) have[abs(links[i].getAttribute('href'))] = 1;

    var waits = [];
    for (i = 0; i < list.length; i++) {
      (function (href) {
        if (!href || have[href] || adopted[href]) return;
        adopted[href] = 1;
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = href;
        waits.push(new Promise(function (res) {
          l.onload = res;
          l.onerror = function () { delete adopted[href]; forget(); res(); };
          setTimeout(res, 2500);
        }));
        document.head.appendChild(l);
      })(list[i]);
    }
    return waits.length ? Promise.all(waits) : Promise.resolve();
  }

  /* ------------------------------------------------------------ run scripts
     Markup written by innerHTML never runs its scripts. Module sources are
     de-duplicated against the document — most are already loaded on every
     template by snippets/scripts.liquid, which is the reason the injected
     custom elements upgrade themselves at all — and the inline ones are the
     product page's own guarded IIFEs, re-created where they stood. */
  var ranSrc = {};
  function runScripts(root) {
    var list = root.querySelectorAll('script'), i;
    for (i = 0; i < list.length; i++) {
      var old = list[i];
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type === 'application/json' || type === 'application/ld+json') continue;

      var src = old.getAttribute('src');
      if (src) {
        var href = abs(src);
        if (ranSrc[href] || document.querySelector('script[src="' + href.replace(/"/g, '\\"') + '"]')) {
          old.parentNode.removeChild(old);
          continue;
        }
        ranSrc[href] = 1;
        var s = document.createElement('script');
        s.src = href;
        if (type) s.type = type;
        document.head.appendChild(s);
        old.parentNode.removeChild(old);
      } else {
        var inline = document.createElement('script');
        inline.textContent = old.textContent;
        old.parentNode.replaceChild(inline, old);
      }
    }
  }

  /* ------------------------------------------------------------- open/close */
  var lastFocus = null;
  var lockedByUs = false;
  var currentHandle = null;

  function lock() {
    var html = document.documentElement;
    if (html.hasAttribute('scroll-lock')) return;   /* somebody else owns it */
    html.setAttribute('scroll-lock', '');
    lockedByUs = true;
  }
  function unlock() {
    if (!lockedByUs) return;
    document.documentElement.removeAttribute('scroll-lock');
    lockedByUs = false;
  }

  /* ---- the back button ------------------------------------------------
     This file did no history work at all. On an article that was survivable —
     you open one product, you read, you close it. Opened repeatedly from a cart
     drawer it is not: Back is how a phone user dismisses a full-screen overlay,
     and with no entry to pop it leaves the site instead, taking the cart with
     it. That is a shopper lost mid-cart.

     One entry per open, at the SAME url. pushState with location.href changes
     nothing the shopper can see or copy, so no product gets a fake address that
     would open the article behind it if it were shared or reloaded — the modal
     is a view of another page, not a page.

     The pair has to be symmetric or the entry becomes a trap: closing by the X,
     the backdrop, Escape or the downward swipe consumes our entry with
     history.back(), so one Back later does not silently undo a navigation that
     already looks finished. `pushed` is cleared BEFORE calling back(), so the
     popstate that results finds nothing to consume and does not re-close a
     dialog that is already closing. */
  /* THE MOUNTED PAGE MUST NOT REWRITE THIS PAGE'S ADDRESS.
     Horizon's variant picker calls replaceState with `?variant=<id>` whenever an
     option changes. That is right on a product page and wrong here: the picker
     inside the modal belongs to a DIFFERENT product, so choosing "Double Finger
     Guard" in a suggestion opened over the cutting board turned the address bar
     into

         /products/stainless-steel-cutting-board?variant=45861650825263

     — the cutting board's url carrying the finger guard's variant. Reload or
     share that and the variant is wrong or ignored. Found by cart_variant_test,
     which counts main-frame navigations as a second witness and reported two
     where the document had not changed at all.

     So while the dialog is open, history writes from anything but this file are
     dropped. Scoped two ways: only while open, and only for calls this file did
     not make (`ownWrite`). The originals are restored by reference, never
     re-derived, so a second script that also wrapped history keeps its wrapper. */
  var realPush = history.pushState;
  var realReplace = history.replaceState;
  var ownWrite = false;
  /* The same rule for a product page EMBEDDED in an article (embed() below),
     2026-10-05: its picker would write ?variant=<id> onto the article's url.
     There is no open/closed state to scope by, so only writes that carry a
     variant are dropped — the article itself never makes one. */
  var embedded = false;
  function dropWrite(args) {
    if (ownWrite) return false;
    if (dlg.open) return true;
    return embedded && /[?&]variant=/.test(String(args[2] || ''));
  }
  history.pushState = function () {
    if (dropWrite(arguments)) return;
    return realPush.apply(history, arguments);
  };
  history.replaceState = function () {
    if (dropWrite(arguments)) return;
    return realReplace.apply(history, arguments);
  };

  var pushed = false;
  function pushHistory() {
    if (pushed) return;
    ownWrite = true;
    try { realPush.call(history, { hlPdpm: 1 }, '', location.href); pushed = true; } catch (e) {}
    ownWrite = false;
  }
  function popHistory() {
    if (!pushed) return;
    pushed = false;
    try { history.back(); } catch (e) {}
  }
  window.addEventListener('popstate', function () {
    pushed = false;               // our entry is the one that just went
    if (dlg.open) close();
  });

  /* STAGED, THEN RISEN, 2026-09-23 — owner: "Animation mở PDP modal khi click
     relate products vẫn giật quá nhiều". Measured at 4x CPU: opening costs one
     page-wide style recalc (~140ms, the store's :has() rules and the top layer)
     plus showModal itself (~180ms). The rise used to START inside that block,
     so by the first frame the compositor got, the 340ms animation was already
     over: the sheet appeared in place, 600ms after the tap, with no motion.

     Now the dialog opens with the panel parked below the screen and no
     animation running (.is-staging). Two frames later — the recalc paid, a
     frame committed — the class comes off and the rise starts; it is a
     transform, so it runs on the compositor whatever the page does next.
     `risen` resolves when it starts, so the mount can wait for its end. */
  var risen = Promise.resolve();
  function show() {
    if (dlg.open) return;
    pushHistory();
    lastFocus = document.activeElement;
    dlg.classList.remove('is-closing');
    dlg.classList.add('is-staging');
    dlg.showModal();
    risen = new Promise(function (res) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dlg.classList.remove('is-staging');
          res();
        });
      });
    });
    /* showModal() hands focus to the first focusable thing it finds, which here
       is the product-name link in the bar — it took a focus ring and read as a
       selected text field. The panel takes the focus instead: the dialog is
       still announced by its aria-label, and nothing wears a ring it did not
       earn by being tabbed to. */
    panel.focus({ preventScroll: true });
    lock();
  }

  function close() {
    if (!dlg.open || dlg.classList.contains('is-closing')) return;
    dlg.classList.add('is-closing');
    var fired = false;
    var done = function () {
      if (fired) return;
      fired = true;
      dlg.classList.remove('is-closing');
      dlg.classList.remove('hl-pdpm--half');
      dlg.close();
      unlock();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      popHistory();
      dlg.dispatchEvent(new CustomEvent('hl-pdpm:close', { bubbles: true, detail: { handle: currentHandle } }));
    };
    dlg.addEventListener('animationend', function h(e) {
      if (e.target !== panel && e.target !== dlg) return;
      dlg.removeEventListener('animationend', h);
      done();
    });
    setTimeout(done, 400);
  }

  /* THE MOUNTED COPY MUST NOT SHARE FORM IDENTIFIERS WITH THE PAGE BEHIND IT.

     variant-main-picker.liquid names its radios "<option>-<block.id>-<product.id>"
     and its selects "Option-<block.id>-<index>". Open this modal for the product
     the page is ALREADY showing — reachable: a shopper on product X adds Y, the
     cart rail suggests X because X is not in the cart, they tap X's card — and
     the mounted picker's radios join the PAGE's radio groups, because a radio
     group is every input in the document sharing a name. Checking Blue in the
     modal then unchecks Black on the page beneath it, silently, and the page's
     own picker is now showing a variant nobody chose. Duplicate ids do the same
     to every <label for> in the copy: the label points at the page's control.

     A prefix on name, id, for and the aria-* attributes that reference ids is
     enough — the page's identifiers are untouched, and the copy's are internally
     consistent because every reference is rewritten in the same pass. Done before
     runScripts(), so the picker's own script sees the scoped names from the
     start rather than re-binding to them afterwards. */
  var NS = 'hlpm-';
  function scopeNames(root, ns) {
    ns = ns || NS;
    /* getAttribute('id'), NOT .id — and this cost an hour. A <form> exposes its
       named controls as properties, and the product form contains
       <input name="id">, so `form.id` returns that INPUT ELEMENT rather than the
       string. `old.indexOf` then threw, render() threw, open()'s catch swallowed
       it and closed the dialog, and every card reported "the modal could not
       open the page product" with the markup already mounted behind it. The
       attribute accessors have no such shadowing. */
    /* Only ids the article ALSO uses are renamed, 2026-09-26. Renaming every id
       broke the product page's own id-scoped CSS inside the modal — #hl-save,
       the "17% off" pill, rendered as plain text — and any <use href="#…">.
       A duplicate id is the only thing this was ever protecting against. */
    var idMap = {};
    var withId = root.querySelectorAll('[id]');
    for (var i = 0; i < withId.length; i++) {
      var old = withId[i].getAttribute('id');
      if (!old || typeof old !== 'string' || old.indexOf(ns) === 0) continue;
      var clash = document.getElementById(old);
      if (!clash || clash === withId[i] || root.contains(clash)) continue;
      idMap[old] = ns + old;
      withId[i].setAttribute('id', idMap[old]);
    }
    var refs = ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'list', 'form'];
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      for (var r = 0; r < refs.length; r++) {
        var v = el.getAttribute(refs[r]);
        if (!v) continue;
        var parts = v.split(/\s+/).map(function (t) { return idMap[t] || t; });
        el.setAttribute(refs[r], parts.join(' '));
      }
      var nm = el.getAttribute('name');
      /* `id` and `quantity` are what the form POSTs to /cart/add.js — renaming
         those would stop the modal adding anything at all. Only the grouping
         names, which is what collides. */
      if (nm && nm !== 'id' && nm !== 'quantity' && nm.indexOf(ns) !== 0
          && (el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA')) {
        el.setAttribute('name', ns + nm);
      }
    }
  }

  function render(data) { renderInto(mount, data, NS); }

  /* THE PRODUCT PAGE'S VARIANT BEHAVIOUR, 2026-10-06 — owner: "product trong
     blogs (embed) cần logic giống y đúc trong PDP … khác khi select variants".
     Choosing a colour on the product page jumps the gallery to that colour's
     photograph (assets/hl-variant-swap.js). In a mount it did nothing: the
     script and its map (#hl-variant-media) are page-level, outside the sections
     that are mounted, so the gallery sat on the hero whatever was picked.
     The script is loaded on first use, not on every article, and the map is
     built from the public product JSON in the shape the page's own node has. */
  var swapReady = null;
  function loadSwap() {
    if (window.HLVariantSwap) return Promise.resolve(window.HLVariantSwap);
    if (swapReady) return swapReady;
    var me = document.querySelector('script[src*="hl-pdp-modal.js"]');
    var src = me && me.getAttribute('src');
    if (!src) return Promise.reject(new Error('no script src'));
    swapReady = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src.replace(/hl-pdp-modal\.js/, 'hl-variant-swap.js');
      s.onload = function () { res(window.HLVariantSwap); };
      s.onerror = function () { swapReady = null; rej(new Error('hl-variant-swap.js')); };
      document.head.appendChild(s);
    });
    return swapReady;
  }
  function sized(u, w) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  var vmaps = {};
  function variantMap(handle) {
    if (!vmaps[handle]) {
      vmaps[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var map = {};
          (p.variants || []).forEach(function (v) {
            var m = v.featured_media, img = m && m.preview_image, src = img && img.src;
            map[v.title] = {
              mediaId: m ? m.id : 0,
              src: src ? sized(src, 1200) : null,
              thumb: src ? sized(src, 144) : null,
              alt: (m && m.alt) || p.title,
              ratio: (img && img.aspect_ratio) || 1
            };
          });
          return map;
        })
        .catch(function (e) { delete vmaps[handle]; throw e; });
    }
    return vmaps[handle];
  }
  /* The first photograph, decoded before the skeleton leaves. The mount is
     display:none while the sheet is loading, so a lazy image would not even
     start; the gallery then painted its picture a beat after everything around
     it, which is the jump. Eager, decoded, and never waited on for long. */
  function firstPhotoReady(root) {
    var img = root.querySelector('media-gallery img');
    if (!img) return Promise.resolve();
    img.loading = 'eager';
    img.fetchPriority = 'high';
    var done = img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    return Promise.race([done, new Promise(function (r) { setTimeout(r, 380); })]);
  }

  /* Text that changes in place settles in: the option's name beside its label,
     the price, the add button's label. */
  var TXT = '.variant-option__swatch-value, product-price, .add-to-cart-text';
  var txtSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function settle(el) {
    el.classList.remove('hl-pm-txt');
    void el.offsetWidth;
    el.classList.add('hl-pm-txt');
    el.addEventListener('animationend', function h(e) {
      if (e.target !== el) return;
      el.removeEventListener('animationend', h);
      el.classList.remove('hl-pm-txt');
    });
  }
  function watchText(root) {
    if (!window.MutationObserver || (txtSeen && txtSeen.has(root))) return;
    if (txtSeen) txtSeen.add(root);
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    new MutationObserver(function (list) {
      var hit = [];
      list.forEach(function (m) {
        var t = m.type === 'characterData' ? m.target.parentElement : m.target;
        var host = t && t.closest && t.closest(TXT);
        if (host && hit.indexOf(host) < 0) hit.push(host);
        [].forEach.call(m.addedNodes || [], function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(TXT) && hit.indexOf(n) < 0) hit.push(n);
          [].forEach.call(n.querySelectorAll ? n.querySelectorAll(TXT) : [], function (x) { if (hit.indexOf(x) < 0) hit.push(x); });
        });
      });
      hit.forEach(settle);
    }).observe(root, { childList: true, characterData: true, subtree: true });
  }
  function attachVariants(el, handle) {
    watchText(el);
    Promise.all([loadSwap(), variantMap(handle)]).then(function (r) {
      r[0].attach(el, r[1]);
    }).catch(function (err) {
      try { console.warn('[hl-pdpm] variant media unavailable:', err && (err.message || err)); } catch (e) {}
    });
  }

  /* `ns` differs per mount: the modal and an embed can show the same product
     at once (the buy bar opens the article's own product), and sharing one
     prefix would join their radio groups — the failure scopeNames exists for. */
  function renderInto(mount, data, ns) {
    mount.textContent = '';
    for (var i = 0; i < data.html.length; i++) {
      if (!data.html[i]) continue;
      var holder = document.createElement('div');
      holder.innerHTML = data.html[i];
      var node = holder.firstElementChild;
      if (node) mount.appendChild(node);
    }
    if (!mount.firstElementChild) throw new Error('empty grid');
    // The styles that travel inside the sections are aimed at the mount too.
    var inner = mount.querySelectorAll('style');
    for (var k = 0; k < inner.length; k++) inner[k].textContent = scopeCss(inner[k].textContent);
    scopeNames(mount, ns);
    runScripts(mount);

    /* media-gallery and slideshow-component measure themselves on connect, and
       on connect this panel is still animating in from translateY(100%). One
       resize after the frame settles is what puts the first slide at the right
       width instead of at zero. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
    });
  }

  /**
   * Open the product page for `handle` over the article. Resolves true when the
   * real markup is up, false when the caller should fall back to its own sheet.
   */
  function open(handle, meta) {
    if (!handle) return Promise.resolve(false);
    currentHandle = handle;

    /* HALF THE SCREEN, WHEN THE CALLER ASKS FOR IT. 2026-09-14, owner, of the
       cart rail: "mo 1 nua man hinh th nhung show giong y duc PDP page UI".

       Only the HEIGHT is halved, never the width. The panel holds
       .product-information, a page-width grid whose columns are computed from
       --full-page-grid-*, and those are derived from the viewport -- narrow the
       box and the grid still measures itself against the window, so the two
       columns overflow it by the difference. That is the finding the full-bleed
       comment in hl-blog-pdp-modal.liquid records, and a half-height sheet does
       not touch it: 100vw wide, bottom-anchored, 62dvh tall, with the panel's
       own scroller doing what it already did.

       The class is set before show() so the entrance animation is the half
       sheet's from the first frame, and cleared on close so the blog's
       full-height call is never left wearing it. */
    dlg.classList.toggle('hl-pdpm--half', !!(meta && meta.half));
    /* A sheet that opens at 75% and stays there makes the shopper read a whole
       product page through a window. Scrolling its content is the signal that
       they want the page, not the peek — so the first scroll takes it to full
       height. Owner: "nếu scroll xuống thì sẽ tự đẩy modal lên 100% heights".

       ONE WAY ONLY, deliberately. Collapsing back at scrollTop 0 would make the
       sheet resize under a finger that is still moving, and on a phone that
       reads as the page fighting back. Once it is full it stays full; the drag
       handle and the X are how it goes away.

       Re-armed on every open because the class is removed on close. */
    dlg.classList.remove('is-full');
    armExpand(dlg);

    /* The crumb ships with no href, hidden and aria-hidden — see the note in
       hl-blog-pdp-modal.liquid. This is where it becomes a real link: it gets its
       destination and its text in the same breath, so there is no frame in which
       it is focusable and nameless. */
    crumb.setAttribute('href', '/products/' + handle);
    crumb.textContent = '';
    var b = document.createElement('b');
    b.textContent = (meta && meta.title) || 'Product';
    crumb.appendChild(b);
    crumb.hidden = false;
    crumb.removeAttribute('aria-hidden');
    crumb.removeAttribute('tabindex');
    full.setAttribute('href', '/products/' + handle);
    full.hidden = true;

    /* THE PAGE GOES IN AFTER THE SHEET HAS ARRIVED, 2026-09-23 — owner: "Hiệu
       ứng xuất hiện của modal PDP khi click relate products đang bị giật".
       Rendering a product page (a gallery, the buy box, their scripts) is a
       long main-thread task, and it used to land in the middle of the rise:
       warm from the cache it ran on the very first frame, cold it arrived
       whenever the fetch did. Either way the sheet stuttered. Now the skeleton
       always rises, the fetch runs alongside, and the markup is only mounted
       once the panel's entrance animation has ended (or its duration has
       passed, if animationend never comes). */
    // The previous product is NOT removed here: tearing a product page out of
    // the DOM is itself a long layout, and it landed on the tap. is-loading
    // hides it (display:none, so it costs nothing); render() replaces it once
    // the sheet has arrived.
    dlg.classList.add('is-loading');
    scroll.scrollTop = 0;
    show();
    var arrived = risen.then(function () {
      return new Promise(function (res) {
        var t = setTimeout(res, dlg.classList.contains('hl-pdpm--half') ? 380 : 540);
        // The half sheet animates the dialog, the full one the panel; either
        // ending is the arrival.
        dlg.addEventListener('animationend', function h(e) {
          if (e.target !== panel && e.target !== dlg) return;
          dlg.removeEventListener('animationend', h);
          clearTimeout(t);
          res();
        });
      });
    });

    return get(handle)
      .then(function (data) { adoptStyles(data.styles); return adoptCss(data.css).then(function () { return data; }); })
      .then(function (data) { return arrived.then(function () { return data; }); })
      .then(function (data) {
        if (currentHandle !== handle) return true;   /* a later open won the race */
        render(data);
        runPageScripts(data.scripts);
        attachVariants(mount, handle);
        return firstPhotoReady(mount).then(function () { return data; });
      })
      .then(function (data) {
        if (currentHandle !== handle) return true;
        dlg.classList.remove('is-loading');
        full.hidden = false;
        scroll.scrollTop = 0;
        dlg.dispatchEvent(new CustomEvent('hl-pdpm:open', {
          bubbles: true,
          detail: { handle: handle, source: (meta && meta.source) || 'tap' }
        }));
        return true;
      })
      .catch(function (err) {
        /* Say what failed. This caught silently, so a TypeError inside render()
           was indistinguishable from a network drop — the caller only ever saw
           `false`, and the fallback path made it look like a slow store rather
           than a bug in this file. */
        try { console.warn('[hl-pdpm] open failed:', err && (err.stack || err.message || err)); } catch (e) {}
        dlg.classList.remove('is-loading');
        if (dlg.open) { dlg.close(); unlock(); dlg.classList.remove('is-closing'); }
        /* The history entry pushed by show() has to go with it. Without this,
           `pushed` stayed true after a failed open and the next Back press was
           swallowed consuming an entry for a dialog that never appeared. */
        popHistory();
        return false;
      });
  }

  /** Warm the markup and the stylesheet without opening anything. */
  function prefetch(handle) {
    if (!handle || cache[handle]) return;
    get(handle).then(function (data) { adoptCss(data.css); }).catch(function () {});
  }

  /* ------------------------------------------------------------------ wiring */
  dlg.querySelector('[data-pm-close]').addEventListener('click', close);
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  /* A <dialog> reports a backdrop click as a click on itself. The panel fills
     the dialog, so anything that lands on the dialog element is the backdrop. */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

  /* Pull down to dismiss: from the handle at any time, and from the body
     whenever it is already scrolled to the top, which is what makes a downward
     drag unambiguous rather than a fight with the scroll. */
  (function () {
    var startY = null, dy = 0, viaHandle = false;
    var handle = dlg.querySelector('[data-pm-grab]');

    function begin(e, fromHandle) {
      if (window.matchMedia('(min-width:750px)').matches) return;
      if (!fromHandle && scroll.scrollTop > 0) return;
      startY = e.touches ? e.touches[0].clientY : e.clientY;
      dy = 0;
      viaHandle = fromHandle;
      panel.style.transition = 'none';
    }
    function move(e) {
      if (startY === null) return;
      var y = e.touches ? e.touches[0].clientY : e.clientY;
      dy = y - startY;
      if (dy < 0) { dy = 0; return; }
      if (!viaHandle && scroll.scrollTop > 0) { startY = null; panel.style.transform = ''; return; }
      if (e.cancelable) e.preventDefault();
      panel.style.transform = 'translateY(' + dy + 'px)';
    }
    function end() {
      if (startY === null) return;
      startY = null;
      panel.style.transition = 'transform .26s cubic-bezier(.32,.72,0,1)';
      panel.style.transform = '';
      if (dy > window.innerHeight / 4) { panel.style.transition = ''; close(); }
    }

    handle.addEventListener('touchstart', function (e) { begin(e, true); }, { passive: true });
    scroll.addEventListener('touchstart', function (e) { begin(e, false); }, { passive: true });
    dlg.addEventListener('touchmove', move, { passive: false });
    dlg.addEventListener('touchend', end);
    dlg.addEventListener('touchcancel', end);
  })();

  /* Adding to the cart from inside the modal closes it, the same way the
     theme's own quick-add dialog closes on a successful cart update.

     This is not a nicety. The cart drawer is not in the top layer and this
     dialog is, so a drawer that opened behind an opaque full-viewport panel
     would be invisible — the reader would tap Add to cart, see the button tick,
     and have no idea anything happened. `shopify:cart:lines-update` is the
     event the theme's own quick-add listens to (StandardEvents.cartLinesUpdate
     in assets/quick-add.js); it is namespaced by Shopify's standard-events
     bundle, which is loaded on every page of this store. */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!dlg.open) return;
    if (!e.target || !dlg.contains(e.target)) return;
    setTimeout(close, 260);
  }, true);

  /* ---- ADD WHILE A VARIANT IS STILL LOADING, 2026-09-23 ------------------
     Owner: "khi bấm vào relate product bấm add thì product hiện tại trong
     cart lại +1 quantity — lỗi nặng". Reproduced: product page opened with
     ?variant=<its variant> (this store reloads on variant pick, so that is the
     common URL), the sheet opened for another product, a variant tapped in
     the sheet and Add pressed at once — the cart got the PAGE's product x2
     and nothing of the sheet's.

     The theme's product form, when Add arrives while a variant change is in
     flight, does not read its own form: it queues
     `new URL(location.href).searchParams.get('variant')` — the page URL's
     variant. On a page that is the product page, that is the page's product.
     The form is the theme's and its state is private, so the fix is here:
     while a product-select inside the sheet is pending, a tap on the sheet's
     Add is held (captured on window, ahead of every other listener, so no
     busy-guard downstream swallows the replay), and replayed once the select
     has settled — by then the form has left that branch and reads its own
     variant. The button shows the same spinner the store uses while it waits. */
  var selectPending = null;
  var SELECT_EVENTS = ['shopify:product:select', 'product:select', 'variant:select'];
  // Every surface that hosts a mounted product: the dialog, plus each embed.
  var selectRoots = [dlg];
  var namesReady = false;
  function watchSelect(name, root) {
    (root || dlg).addEventListener(name, function (e) {
      var p = e && e.promise;
      if (!p || typeof p.then !== 'function') return;
      var mine = selectPending = p.then(function () {}, function () {});
      mine.then(function () { if (selectPending === mine) selectPending = null; });
    }, true);
  }
  import('@shopify/events').then(function (m) {
    var n = m && m.StandardEvents && m.StandardEvents.productSelect;
    if (n && SELECT_EVENTS.indexOf(n) === -1) SELECT_EVENTS.push(n);
  }).catch(function () {}).then(function () {
    namesReady = true;
    selectRoots.forEach(function (r) { SELECT_EVENTS.forEach(function (n) { watchSelect(n, r); }); });
  });

  window.addEventListener('click', function (e) {
    if (!selectPending) return;
    var btn = e.target && e.target.closest && e.target.closest(
      '.hl-pdpm button[name="add"], .hl-pdpm .add-to-cart-button, ' +
      '[data-hl-embed] button[name="add"], [data-hl-embed] .add-to-cart-button');
    if (!btn) return;
    if (dlg.contains(btn) && !dlg.open) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.dataset.hlHeld) return;              // one replay per hold
    btn.dataset.hlHeld = '1';
    btn.setAttribute('aria-busy', 'true');
    var wait = selectPending;
    var timeout = new Promise(function (res) { setTimeout(res, 5000); });
    Promise.race([wait, timeout]).then(function () {
      requestAnimationFrame(function () {
        delete btn.dataset.hlHeld;
        btn.removeAttribute('aria-busy');
        if (selectPending) return;               // still loading after 5s: do not guess
        btn.click();
      });
    });
  }, true);

  /**
   * Mount the product page for `handle` INSIDE `el`, in the flow of the page —
   * the article's lead product, 2026-10-05 (owner: replace the first
   * hl-leadcta with the PDP itself, embedded, not a link to click). Same
   * markup, styles and scripts as open(); `el` must carry data-pm-mount so the
   * product page's #MainContent-scoped rules (re-aimed by scopeCss) reach it.
   * Resolves true when mounted, false when the caller should keep its fallback.
   */
  function embed(handle, el, opts) {
    if (!handle || !el) return Promise.resolve(false);
    /* opts.mainOnly: the buy section alone, no description under it (owner,
       2026-10-05: "chỉ show cart lớn đầu product-information … không cần show
       description"). SECTIONS puts 'main' first, so it is html[0]. */
    var mainOnly = !!(opts && opts.mainOnly);
    return get(handle)
      .then(function (data) { adoptStyles(data.styles); return adoptCss(data.css).then(function () { return data; }); })
      .then(function (data) {
        embedded = true;
        renderInto(el, mainOnly ? { html: data.html.slice(0, 1) } : data, 'hlpe-');
        runPageScripts(data.scripts);
        attachVariants(el, handle);
        selectRoots.push(el);
        if (namesReady) SELECT_EVENTS.forEach(function (n) { watchSelect(n, el); });
        return true;
      })
      .catch(function (err) {
        try { console.warn('[hl-pdpm] embed failed:', err && (err.stack || err.message || err)); } catch (e) {}
        return false;
      });
  }

  window.HLBlogPDP = { open: open, close: close, prefetch: prefetch, embed: embed, el: dlg };
})();
